import React, { useEffect, useMemo, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { listTeachers } from "../../services/teacher";
import { useTranslation } from "../../i18n/I18nContext";

const PAGE_SIZE = 6;

const getInitials = (name) =>
  (name || "?")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");

const TopPerformanceTwo = () => {
  const { t } = useTranslation();
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    listTeachers()
      .then((resp) => setTeachers(resp.data || []))
      .catch(() => setTeachers([]))
      .finally(() => setLoading(false));
  }, []);

  const totalPages = Math.max(1, Math.ceil(teachers.length / PAGE_SIZE));

  const pageTeachers = useMemo(
    () => teachers.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE),
    [teachers, page],
  );

  const goToPage = (nextPage) => {
    if (nextPage < 1 || nextPage > totalPages) return;
    setPage(nextPage);
  };

  return (
    <div className='col-xxl-4'>
      <div className='card'>
        <div className='card-header border-bottom'>
          <div className='d-flex align-items-center flex-wrap gap-2 justify-content-between'>
            <h6 className='mb-2 fw-bold text-lg mb-0'>{t('menu.professores.lista')}</h6>
          </div>
        </div>
        <div className='card-body'>
          <div className='d-flex flex-column gap-24'>
            {loading && <span className='text-secondary-light'>{t('dashboard.loading')}</span>}
            {!loading && teachers.length === 0 && (
              <span className='text-secondary-light'>{t('dashboard.teachers.empty')}</span>
            )}
            {pageTeachers.map((teacher) => (
              <div
                key={teacher.id}
                className='d-flex align-items-center justify-content-between gap-3'
              >
                <div className='d-flex align-items-center'>
                  <span className='w-40-px h-40-px rounded-circle flex-shrink-0 me-12 bg-primary-100 text-primary-600 d-flex align-items-center justify-content-center fw-semibold'>
                    {getInitials(teacher.name)}
                  </span>
                  <div className='flex-grow-1'>
                    <h6 className='text-md mb-0'>{teacher.name}</h6>
                    <span className='text-sm text-secondary-light fw-medium'>
                      {teacher.subjectName || "-"}
                    </span>
                  </div>
                </div>
                <span className='text-sm text-secondary-light'>{teacher.contact || teacher.email || ""}</span>
              </div>
            ))}
          </div>

          {!loading && teachers.length > PAGE_SIZE && (
            <ul className='pagination d-flex flex-wrap align-items-center gap-2 justify-content-center mt-24 mb-0'>
              <li className='page-item'>
                <button
                  type='button'
                  className='page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px w-32-px bg-base'
                  onClick={() => goToPage(page - 1)}
                  disabled={page === 1}
                >
                  <Icon icon='ep:d-arrow-left' className='text-xl' />
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                <li key={p} className='page-item'>
                  <button
                    type='button'
                    className={`page-link fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px w-32-px ${
                      p === page
                        ? "bg-primary-600 text-white"
                        : "bg-primary-50 text-secondary-light"
                    }`}
                    onClick={() => goToPage(p)}
                  >
                    {p}
                  </button>
                </li>
              ))}
              <li className='page-item'>
                <button
                  type='button'
                  className='page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px w-32-px bg-base'
                  onClick={() => goToPage(page + 1)}
                  disabled={page === totalPages}
                >
                  <Icon icon='ep:d-arrow-right' className='text-xl' />
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopPerformanceTwo;
